import { useState } from 'react';
import { X, Truck } from 'lucide-react';

export const AnnouncementBar = () => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div className="relative bg-gradient-to-r from-[#5db870] via-[#8acb95] to-[#5db870] text-white text-sm py-2.5 px-4">
      <div className="container mx-auto max-w-7xl flex items-center justify-center gap-2 text-center pr-8">
        <Truck className="w-4 h-4 flex-shrink-0" />
        <p className="font-medium">
          WhatsApp us for bulk &amp; wholesale orders
        </p>
      </div>
      <button
        onClick={() => setDismissed(true)}
        className="announcement-close absolute right-4 top-1/2 -translate-y-1/2 text-white/80 hover:text-white transition-opacity"
        aria-label="Dismiss announcement"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
